export const accessors = (target, source, fn)=>Object.defineProperties(target, Object.fromEntries(Object.entries(source).map(([key, value])=>{
        const next = fn(key, value);
        const prev = Object.getOwnPropertyDescriptor(target, key);
        if (prev && prev.get && prev.set) {
            const { get , set  } = next;
            next.get = ()=>prev.get?.() ?? get()
            ;
            next.set = (v)=>{
                prev.set?.(v);
                set(prev.get?.() ?? v);
            };
        }
        return [
            key,
            {
                configurable: true,
                enumerable: true,
                ...next
            }
        ];
    })))
;
export const kebab = (s)=>s.replace(/[a-z](?=[A-Z])|[A-Z]+(?=[A-Z][a-z])/g, '$&-').toLowerCase()
;
